export default {
  contact_provider: 'Contacte o seu fornecedor para ativar esta opção.',
};
